export const shoppingApiBaseUrl = (locale?: string) => {
  if (locale === 'zh_cn') return process.env.NEXT_PUBLIC_CN_SHOPPING_API_ENDPOINT;
  return process.env.NEXT_PUBLIC_SHOPPING_API_ENDPOINT;
};
